import React from 'react'
import PropTypes from 'prop-types'
import { classifyRating } from './classifyRating'

const NpsRatingPropTypes = {
  rating: PropTypes.number
}

type NpsRatingProps = PropTypes.InferType<typeof NpsRatingPropTypes>

const renderRating = (rating: number): React.ReactElement => (
  <>
    <span className='color-pro-steel-grey-600'>{rating}</span>
  </>
)

const renderNoRating = (): React.ReactElement => (
  <span className={classifyRating(null)}>N/A</span>
)

const renderContent = (rating: number): React.ReactElement => {
  if (rating == null) {
    return renderNoRating()
  } else {
    return renderRating(rating)
  }
}

export const NpsRating = ({ rating }: NpsRatingProps): React.ReactElement => {
  return (
    <span data-testid='nps-rating'>
      {renderContent(rating)}
    </span>
  )
}

NpsRating.propTypes = NpsRatingPropTypes
